import React from 'react';

function AcceptableIcon({active = false}) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.9941 11.1718V11.9993C20.993 13.9388 20.365 15.826 19.2037 17.3794C18.0424 18.9328 16.4101 20.0693 14.5502 20.6192C12.6902 21.1691 10.7024 21.1031 8.88305 20.4309C7.06373 19.7588 5.51042 18.5165 4.45478 16.8895C3.39914 15.2624 2.89774 13.3377 3.02536 11.4024C3.15297 9.46705 3.90276 7.62483 5.16291 6.15046C6.42305 4.6761 8.12603 3.64857 10.0179 3.22114C11.9097 2.7937 13.889 2.98926 15.6606 3.77864'
        stroke={active ? `#0DB091` : `#999999`}
        strokeWidth='1.79883'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.9941 4.80371L12 13.8068L9.30176 11.1086'
        stroke={active ? `#0DB091` : `#999999`}
        strokeWidth='1.79883'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default AcceptableIcon;
